import { FC, useCallback, useMemo, useState } from "react";
import { FinancialAccount } from "@common/types/financialAccount";
import { ChildrenProps } from "../../types";
import {
    ConnectAccountContext,
    ConnectAccountState,
} from "./ConnectAccount.context";

export const ConnectAccountStateProvider: FC<ChildrenProps> = ({
    children,
}) => {
    const [currentState, setCurrentState] = useState<ConnectAccountState>({
        isConnecting: false,
    });

    const updateFinancialAccount = useCallback(
        (account: FinancialAccount) =>
            setCurrentState((state) => {
                if (state.connection?.accounts) {
                    return {
                        ...state,
                        connection: {
                            ...state.connection,
                            accounts: state.connection.accounts.map((ia) => ({
                                ...ia,
                                financialAccount:
                                    ia.financialAccount?.id === account.id
                                        ? account
                                        : ia.financialAccount,
                            })),
                        },
                    };
                }

                if (state.integrationConnection?.integrationAccounts) {
                    return {
                        ...state,
                        integrationConnection: {
                            ...state.integrationConnection,
                            integrationAccounts:
                                state.integrationConnection.integrationAccounts.map(
                                    (ia) => ({
                                        ...ia,
                                        financialAccount:
                                            ia.financialAccount?.id ===
                                            account.id
                                                ? account
                                                : ia.financialAccount,
                                    }),
                                ),
                        },
                    };
                }

                return state;
            }),
        [],
    );

    const updateConnectAccountState = useCallback(
        (newState: ConnectAccountState) => {
            setCurrentState(newState);
        },
        [],
    );

    const value = useMemo(
        () => ({
            state: currentState,
            updateConnectAccountState,
            updateFinancialAccount,
        }),
        [currentState, updateFinancialAccount, updateConnectAccountState],
    );

    return (
        <ConnectAccountContext.Provider value={value}>
            {children}
        </ConnectAccountContext.Provider>
    );
};
